import { useRouter, type RouterContext, type RouterDataContext } from '@atlassian/jira-router';

export function useIsAppUrl() {
	const [{ location }] = useRouter();
	return isAppUrl(location.pathname);
}

export function isAppRoute(routerContext: RouterContext | RouterDataContext) {
	const { match } = routerContext;
	return isAppUrl(match.path);
}

function isAppUrl(pathname: string) {
	return pathname.startsWith('/jira/apps/');
}
